//
//
//
//
//
//
//
//
//
//
//
//
//
//
import EntityContent from 'src/components/Dashboard/Calendar/Cards/EntityContent';
import moment from 'moment';
export default {
  components: {
    EntityContent: EntityContent
  },
  props: {
    calendarEntity: {
      type: Object,
      required: true
    },
    registerTimeDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      saving: false
    };
  },
  computed: {
    cardStyle: function cardStyle() {
      var style = {
        backgroundColor: this.calendarEntity.event.backgroundColor,
        borderLeft: "3px solid ".concat(this.calendarEntity.event.borderColor),
        color: this.calendarEntity.event.textColor,
        '--card-color': this.calendarEntity.event.borderColor
      };

      if (this.isMobile) {
        style.pointerEvents = 'none';
      }

      if (this.timelineMode) {
        style.minHeight = "".concat(this.minHeight, "px");
      }

      return style;
    },
    entity: function entity() {
      return this.calendarEntity.event.entity ? this.calendarEntity.event.entity : this.calendarEntity.event.extendedProps.entity;
    },
    entityType: function entityType() {
      return this.entity.type ? this.entity.type : this.entity.entry_id ? 'entry' : this.entity.timer_id ? 'timer' : 'suggestion';
    },
    displayEntityMinutes: function displayEntityMinutes() {
      return parseInt(this.getEventDuration(this.calendarEntity.event.start, this.calendarEntity.event.end));
    }
  },
  methods: {
    getEventDuration: function getEventDuration(start, end) {
      var duration = moment.duration(moment(end).diff(moment(start)));
      return duration.asMinutes();
    }
  }
};